module.exports = __webpack_public_path__ + "img/icon_tourism.93bf4ad.svg";